import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  updateProfile
} from 'firebase/auth';
import './AuthPage.css';
import toast from 'react-hot-toast';
import googleIcon from '../assets/google-icon.png';
import { Helmet } from 'react-helmet-async';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function AuthPage() {
  const query = useQuery();
  const navigate = useNavigate();
  const initialMode = query.get('mode') === 'signup' ? false : true;
  const [isLogin, setIsLogin] = useState(initialMode);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');

  const toggleMode = () => {
    setIsLogin(!isLogin);
    setError('');
    setUsername('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password);
        toast.success('Connexion réussie 👋');
      } else {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        await updateProfile(userCredential.user, { displayName: username });
        toast.success('Compte créé avec succès 🎉');
      }
      navigate('/');
    } catch (err) {
      setError(err.message);
      toast.error('Une erreur est survenue');
    }
  };

  const handleGoogle = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      toast.success('Connecté avec Google ✅');
      navigate('/');
    } catch (err) {
      setError(err.message);
      toast.error('Connexion avec Google échouée ❌');
    }
  };

  return (
    <div className="auth-container animated-fade-in">
      <Helmet>
        <title>{`${isLogin ? "Connexion" : "Créer un compte"} | Gates of Music`}</title>
        <meta
          name="description"
          content={
            isLogin
              ? "Connectez-vous pour réserver des musiciens ou gérer votre profil sur Gates of Music."
              : "Créez un compte pour réserver facilement des musiciens talentueux sur Gates of Music."
          }
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <h2>{isLogin ? 'Connexion' : 'Créer un compte'}</h2>

      <form onSubmit={handleSubmit}>
        {!isLogin && (
          <input
            type="text"
            placeholder="Nom d'utilisateur"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
        )}
        <input
          type="email"
          placeholder="Email"
          required
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Mot de passe"
          required
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        {error && <p className="error">{error}</p>}

        <button type="submit">
          {isLogin ? 'Se connecter' : 'Créer un compte'}
        </button>
      </form>

      <button onClick={handleGoogle} className="google-button">
        <img src={googleIcon} alt="Google" className="google-icon" />
        Se connecter avec Google
      </button>

      <p>
        {isLogin ? "Pas encore de compte ?" : "Déjà inscrit ?"}{" "}
        <button onClick={toggleMode} className="switch-mode">
          {isLogin ? "Créer un compte" : "Se connecter"}
        </button>
      </p>
    </div>
  );
}
